import { Container, Typography } from '@mui/material';
import Box from '@mui/material/Box';
import React from 'react';

function Section({
  title,
  color,
  backgroundColor,
  children,
  innerRef
}: {
  title: string;
  color: string;
  backgroundColor: string;
  children: React.ReactNode;
  innerRef?: React.RefObject<any>;
}) {
  return (
    <Box
      sx={{
        position: 'relative',
        width: '100%',
        // ensure all sections fill at least the full viewport height
        minHeight: '100vh',
        py: { xs: 2, sm: 5, md: 6 }, // Reduced mobile padding
        px: { xs: 2, sm: 3, md: 4 }, // Responsive horizontal padding
        overflow: 'visible',
        display: 'flex',
        flexDirection: 'column',
        boxSizing: 'border-box',
        scrollSnapAlign: 'start',
        scrollSnapStop: 'always',
      }}
      ref={innerRef as any}
    >
      {/* Full-width color tint across the entire section */}
      <Box
        aria-hidden
        sx={{
          position: 'absolute',
          inset: 0,
          backgroundColor: backgroundColor,
          opacity: 0.93,
          zIndex: 0,
          pointerEvents: 'none',
        }}
      />

      <Container 
        maxWidth="md" 
        sx={{ 
          position: 'relative', 
          zIndex: 1,
          display: 'flex',
          flexDirection: 'column',
          flex: 1,
        }}
      >
        <Box sx={{ position: 'relative', zIndex: 1, display: 'flex', flexDirection: 'column', flex: 1 }}>
          <Typography
            id={title}
            variant="h4"
            component="h1"
            sx={{
              color,
              mb: { xs: 1.5, sm: 3, md: 4 }, // Reduced mobile margin
              textAlign: 'left',
              fontWeight: 700,
              fontFamily: 'FUTURAM',
              letterSpacing: { xs: 1, sm: 2, md: 3 }, // Responsive letter spacing
            }}
          >
            {title}
          </Typography>

          <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1 }}>{children}</Box>
        </Box>
      </Container>
    </Box>
  );
}

export default Section;